import React from "react";
import Regions from "./Regions";
import { useDispatch } from "react-redux";
import {
  setCanvasMode,
  deleteAllFields,
} from "../../../../redux/reducers/TemplateField";

type Props = {};

export const RegionsReadOnly: React.SFC<Props> = () => {
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(setCanvasMode({ canvasMode: "viewExtractedData" }));
    dispatch(deleteAllFields());
  }, [dispatch]);

  return <Regions />;
};
export default RegionsReadOnly;
